export const NOTIFY_CUSTOMER_READY_PICKUP_LABEL = 'Imprimir QR en el ticket para seguir el pedido';

export function notifyCustomerReadyPickupDescription(hasKitchenTickets: boolean): string {
  if (hasKitchenTickets) {
    return 'El cliente lo escanea para seguir el pedido y ver cuándo está listo.';
  }
  return 'Activá comandas de cocina en esta sucursal.';
}
